const Analysis =()=>import('@/page/Analysis')
const Analysislist = ()=>import('@/page/analysis/analysislist')
const analysispage = ()=>import('@/page/analysis/analysis')
const studentDtk = ()=>import('@/page/analysis/studentDtk')





export default{
	path:'/Analysis',
	component:Analysis,
	children:[
   {
   	path:'',
   	redirect:'Analysislist'
   },
   {
   	path:'Analysislist',
   	name:'Analysislist',
   	component:Analysislist,
   },{
   	path:'analysispage',
   	name:'analysispage',
   	component:analysispage,
   },{
   	path:'studentDtk',
   	name:'studentDtk',
   	component:studentDtk,
   },
	]

}



// WEBPACK FOOTER //
// ./src/router/analysis.js